<template>
  <div ref="dropdownRef" :class="[block?'relative':'relative inline-block','text-left']">
    <tw-button :variant="variant" size="sm" :block="block" @click="toggle">
      <slot name="button" />
      <template v-if="!noDropdownIcon">
        <ChevronDownIcon v-if="isOpen" class="-mr-1 h-5 w-5 text-gray-400 float-right" aria-hidden="true" />
        <ChevronRightIcon v-else class="-mr-1 h-5 w-5 text-gray-400 float-right" aria-hidden="true" />
      </template>
    </tw-button>
    <div v-if="isOpen" :class="[block? 'w-full':'min-w-52', 'origin-top-right absolute right-0 mt-1 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50']">
      <div class="py-1">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, provide, onMounted, onBeforeUnmount } from 'vue'
import TwButton from '@/components/generic/tw-button.vue'
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/vue/20/solid/index.js'

export default defineComponent({
  name: 'TwDropdown',
  components: { ChevronDownIcon, ChevronRightIcon,TwButton },
  props: {
    variant: {
      type: String,
      default: 'light',
    },
    block: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    noDropdownIcon: {
      type: Boolean,
      default: false,
    }
  },
  setup() {
    const isOpen = ref(false)
    const dropdownRef = ref(null)

    const toggle = () => {
      isOpen.value = !isOpen.value
    }

    const close = () => {
      isOpen.value = false
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        close()
      }
    }

    provide('closeDropdown', close)

    onMounted(() => {
      document.addEventListener('click', handleClickOutside)
    })

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside)
    })

    return {
      isOpen,
      dropdownRef,
      toggle,
    }
  },
})
</script>
